export default function Description({ title, children, vertical = false, showDoubleColon = true, titleClassName = "" }) {

    return (
        <div className={`flex gap-2 ${vertical ? 'flex-col' : ''}`}>
            <span className={`${titleClassName}`}>
                {title}{showDoubleColon ? ':' : ''}
            </span>
            <div>
                {children}
            </div>
        </div>
    );
}